module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_common_danger.c499d759.gif";